import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {CopyToClipboardState} from './types';
import css from './index.styl?inline';
import {template} from './template';

export class CopyToClipboard extends Component<CopyToClipboardState> {
  private copiedTimeout;

  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      value: {
        description: `The value to be copied`,
        type: `string`,
      },
      label: {
        description: `The label to be displayed on top of the input`,
        type: `string`,
        default: ``,
      },
    };
  }

  get config() {
    return {
      useShadowDom: true,
      template,
      css,
      defaultState: {
        copyElement: null,
        isCopied: false,
      },
      helpers: {
        handleInsert: (copyEl: HTMLInputElement) => {
          this.update({copyElement: copyEl});
        },
        copyValue: () => {
          this.state.copyElement.select();
          if (document.execCommand(`copy`)) {
            this.update({isCopied: true});
            this.copiedTimeout = window.setTimeout(this.helpers.clearCopied, 2000);
          }
        },
        clearCopied: () => {
          this.update({isCopied: false});
          window.clearTimeout(this.copiedTimeout);
        },
      },
    };
  }
}

export const CopyToClipboardEl = defineAndMakeJsxFactory(`mp-copy-to-clipboard`, CopyToClipboard);
